import { buildAxiosInstance, buildMakeUseAxios } from "@root/api/api.tools";

const baseUrl = `${import.meta.env.VITE_SETTING_SERVICE_URL}`;
export const axiosSettings = buildMakeUseAxios(baseUrl);
export const axiosInstance = buildAxiosInstance(baseUrl);
